import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { $auth } from 'ziphy-web-shared/basic/entities/auth';
import { checkAttachmentType } from '../../../utils/checkAttachments';
import styles from './styles.module.scss';
import { AttachmentRequirementVerificationMessage } from './ui/AttachmentRequirementVerification/AttachmentRequirementVerification';
import { ChatMessageClientBase } from './ui/ChatMessageClientBase/ChatMessageClientBase';
import { ClientAttachmentPostVisit } from './ui/ClientAttachmentPostVisit/ClientAttachmentPostVisit';
import { ConsultationCompleteAttachment } from './ui/ConsultationCompleteAttachment/ConsultationCompleteAttachment';
import { IntakeCompleteAttachment } from './ui/IntakeCompleteAttachment/IntakeCompleteAttachment';
import { LabResultsAttachments } from './ui/LabResultsAttachments/LabResultsAttachments';
import { TelehealtAttachment } from './ui/TelehealthAttachment/TelehealthAttachment';
import { TelehealthReminder } from './ui/TelehealthReminder/TelehealthReminder';
import { TestResultsReminder } from './ui/TestResultsReminder/TestResultsReminder';
export const ChatMessageClient = ({ consultation, message, actions, onActionClick, onAttachmentClick, showTimestamp = true, }) => {
    const role = $auth.role;
    const isOutcome = message.role_id === role.id || message.isDraft;
    const ContainerClass = isOutcome ? styles.rightMessageContainer : styles.leftMessageContainer;
    if (message.attachments && message.attachments.length > 0) {
        if (checkAttachmentType(message, 'attachment_requirement')) {
            return (_jsx(TestResultsReminder, { message: message, consultation: consultation, onActionClick: onActionClick }));
        }
        if (checkAttachmentType(message, 'telehealth_appointment')) {
            return (_jsx(TelehealtAttachment, { consultation: consultation, message: message, onActionClick: onActionClick }));
        }
        if (checkAttachmentType(message, 'telehealth_appointment_reminder')) {
            return (_jsx(TelehealthReminder, { consultation: consultation, message: message, onActionClick: onActionClick }));
        }
        if (checkAttachmentType(message, 'consultation_complete')) {
            return _jsx(ConsultationCompleteAttachment, { message: message });
        }
        if (checkAttachmentType(message, 'intake_complete')) {
            return _jsx(IntakeCompleteAttachment, { message: message });
        }
        if (checkAttachmentType(message, 'post_visit_notes') ||
            checkAttachmentType(message, 'medication_prescription')) {
            return _jsx(ClientAttachmentPostVisit, { message: message, containerClass: ContainerClass });
        }
        if (checkAttachmentType(message, 'attachment_requirement_verified')) {
            const attachment = message.attachments.find((el) => el.type === 'attachment_requirement_verified');
            if (!attachment) {
                return null;
            }
            return (_jsx(AttachmentRequirementVerificationMessage, { consultation: consultation, onActionClick: onActionClick, attachment: attachment }));
        }
        return (_jsx(LabResultsAttachments, { message: message, consultation: consultation, onAttachmentClick: onAttachmentClick, containerClass: ContainerClass }));
    }
    return (_jsx(ChatMessageClientBase, { role: role.role, message: message, actions: actions, onActionClick: onActionClick, showTimestamp: showTimestamp, containerClass: ContainerClass, isOutcome: isOutcome }));
};
export default ChatMessageClient;
